import Spinner from 'components/shared/app/Spinner';
import { ErrorMessages } from 'lib/AppErrors';
import { ValidationUtils } from 'lib/utils/Validation';
import FormRowEditField from 'components/pages/Account/ProfileForm/FormRowEditField';
import Button from 'components/shared/app/Button';
import AuthService from 'lib/services/AuthService';
import React, { useState } from 'react';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';

const SignupProfile = (props) => {
    const [name, setName] = useState(props.profile.name || '');
    const [accountName, setAccountName] = useState(props.profile.accountName || '');
    const [email, setEmail] = useState(props.profile.email || '');
    const [password, setPassword] = useState(props.profile.password || '');
    const [error, setError] = useState(props.error);

    const submit = async () => {
        if (!email || !name || !password) {
            return setError("Please enter all fields.");
        }

        if (password.length < 8) {
            return setError("Password must be at least 8 letters.");
        }

        if (!ValidationUtils.isStrongPassword(password)) {
            return setError(ErrorMessages.passwordValidationError(password));
        }

        let exists = await AuthService.checkEmailExists(email);
        if (exists) {
            return setError("Email is already in use.");
        }

        props.submitProfile(email, password, name, accountName);
    };

    onEnter = (e) => {
        if (e.keyCode == 13) {
            console.log(`submit`)
            submit();
        }
    };

    return (
        <div className="step signup-profile form">

            <div className="font-plain-large bold pad md center">Enter Your Profile Information:</div>

            <div className="flex-col user-info">
                <FormRowEditField label="Full Name" autoComplete="name" placeholder="Full Name"
                    value={name}
                    alwaysEdit={true}
                    saveOnBlur={true}
                    saveOnEnter={true}
                    onSave={(v, cb) => { setName(v); cb(v); }}
                    onEnter={onEnter} />

                <FormRowEditField label="Brand Name" placeholder="Brand Name"
                    value={accountName}
                    alwaysEdit={true}
                    saveOnBlur={true}
                    saveOnEnter={true}
                    onSave={(v, cb) => { setAccountName(v); cb(v); }}
                    onEnter={onEnter} />

                <FormRowEditField label="Email" autoComplete="email" placeholder="Email"
                    value={email}
                    alwaysEdit={true}
                    saveOnBlur={true}
                    saveOnEnter={true}
                    onSave={(v, cb) => { setEmail(v); cb(v); }}
                    onEnter={onEnter} />

                <FormRowEditField type="password" label="Password" placeholder="Password"
                    value={password}
                    alwaysEdit={true}
                    saveOnBlur={true}
                    saveOnEnter={true}
                    onSave={(v, cb) => { setPassword(v); cb(v); }}
                    onEnter={onEnter} />
            </div>

            <div className="button-row col margin lg ns">
                <Button className="margin lg" round simple bold filled center color="white" icon={props.loading ? <Spinner size="fit" className="icon" color="blue" /> : <img src={arrowIcon} />} iconPosition="right" textPosition="center" onClick={submit}>
                    Submit
                </Button>
                <Button className="margin lg" round simple bold center color="white" textPosition="center" onClick={() => props.setSignupState(1)}>
                    Back
                </Button>
            </div>

            {error != '' && <div className="error status center font-plain-medium">{error}</div>}

        </div>
    );
};

export default SignupProfile;